import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'

export interface JobExtensionProgressionNotStartedActionsContainerProps {
  vm: JobProgressionViewModel
}

export const JobExtensionProgressionNotStartedActionsContainer = observer(
  function JobExtensionProgressionNotStartedActionsContainer({
    vm,
  }: JobExtensionProgressionNotStartedActionsContainerProps) {
    if (!vm.isAnyExtensionFlowAvailable) {
      return null
    }

    return <TaxExtensionProgressionActionsContainer vm={vm} />
  },
)
